import { render, staticRenderFns } from "./ProfileSkillApprove.vue?vue&type=template&id=9506dae8"
import script from "./ProfileSkillApprove.vue?vue&type=script&lang=js"
export * from "./ProfileSkillApprove.vue?vue&type=script&lang=js"
import style0 from "./ProfileSkillApprove.vue?vue&type=style&index=0&id=9506dae8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports